import { render, staticRenderFns } from "./TheMyFavoritesProblemWithAddToCartPanelItem.vue?vue&type=template&id=59f98f7b&scoped=true"
import script from "./TheMyFavoritesProblemWithAddToCartPanelItem.vue?vue&type=script&lang=js"
export * from "./TheMyFavoritesProblemWithAddToCartPanelItem.vue?vue&type=script&lang=js"
import style0 from "./TheMyFavoritesProblemWithAddToCartPanelItem.vue?vue&type=style&index=0&id=59f98f7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f98f7b",
  null
  
)

export default component.exports